<template>
    <v-layout column class="shiftUp" :class="{ loading: rcLoading }">
        <HelpRoomCollections />
        <EmployeeAutocomplete v-if="showImpersonate"
            :outline="true"  
            class="mx-2 mb-2"
            :label="'Choose user to view collections'" 
            v-on:return-employee="retrieveCollectionsByUser"
        />
        <v-layout v-else-if="!linkMode" row class="mb-3">            
            <v-flex>
                <v-subheader class="subheading">Collection Groups</v-subheader>
            </v-flex>
            <v-flex xs1 class="text-xs-right">
                <v-tooltip left>
                    <v-btn  slot="activator" icon @click="toggleShowOrdering"><v-icon>unfold_more</v-icon></v-btn>
                    <span>Order Groups</span>
                </v-tooltip>
            </v-flex>
            <v-flex xs1 class="text-xs-right">
                <v-tooltip left>
                    <v-btn  slot="activator" icon @click="addGroup"><v-icon :class="{emptyCollection: collections && collections.length==0}">add</v-icon></v-btn>
                    <span>Add Group</span>
                </v-tooltip>
            </v-flex>
        </v-layout>
        <v-layout v-else justify-space-between>
            <v-flex><v-subheader class="mt-2">A Room Collection link shared with you:</v-subheader></v-flex>
            <v-flex class="text-xs-right"><v-btn @click="switchCollections">Switch to My Collections</v-btn></v-flex>            
        </v-layout>

        <v-expansion-panel v-model="groupsOpen" expand popout v-if="collections">
        <v-expansion-panel-content v-if="!showReorder || showReorder && isOwner(group)" v-for="(group, groupIndex) in collections" :key="groupIndex" class=""
            :style="darkTheme ? 'background-color: #424242 !important;' : 'background-color: rgb(244 244 244) !important;'"  >
            <template v-slot:header v-if="group.groupName != 'IF Auto Group'">
                <v-layout style="height: 50px;">
                <v-flex xs1 v-if="showReorder">
                    <v-icon @click.stop="changeOrder(collections, groupIndex, 'up')" style="position: relative; top: 6px;">expand_less</v-icon>
                    <!-- {{group.order}} -->
                    <v-icon @click.stop="changeOrder(collections, groupIndex, 'down')" style="position: relative; top: -6px;">expand_more</v-icon>
                </v-flex>
                <v-layout column>
                <v-layout row align-center>
                <v-flex shrink v-if="isOwner(group) || isEditor(group)" style="font-size: 14pt;">
                    <v-tooltip top >
                        <v-edit-dialog @click.native.stop
                                    slot="activator"
                                    :return-value.sync="group.groupName"
                                    @save="rcUpdateGroup(group)"
                                    lazy>
                                    {{ group.groupName }} 
                                    
                                    <v-text-field                             
                                      slot="input"
                                      v-model="group.groupName"
                                      label="Group Name"
                                      single-line
                                      
                                      counter
                                    ></v-text-field>
                        </v-edit-dialog>               
                        <span>Edit Group Name</span>
                    </v-tooltip>
                </v-flex>
                <v-flex shrink v-else style="font-size: 14pt;">
                    {{ group.groupName}}
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs6 class="mr-3" v-if="!showReorder && groupsOpen[groupIndex]">
                    <v-layout row >
                        <v-flex>
                            <v-tooltip top>
                                <v-btn slot="activator" icon @click.stop="highlightRooms(group, false)">
                                    <v-icon>control_camera</v-icon>
                                </v-btn>
                                <span>Center and Apply Color</span>
                            </v-tooltip>
                        </v-flex>
                       
                        <v-flex v-if="isOwner(group) || isEditor(group)" >
                            <v-tooltip top>                                                
                            <ShareCollectionGroupDialog slot="activator" :group="group" />   
                            <span>Share Collection Group</span>
                            </v-tooltip> 
                        </v-flex>
                                <v-flex v-else>
                                    <v-tooltip top>                                                
                                    <v-btn slot="activator" icon><v-icon color="grey" @click.stop="">
                                        share
                                    </v-icon></v-btn>   
                                    <span>Not Owner</span>
                                    </v-tooltip>
                                </v-flex>
                        
                        <v-flex v-if="isOwner(group) || isEditor(group)">
                            <v-tooltip top>
                                <v-btn  slot="activator" icon @click.stop="addCollection(group, groupIndex)"><v-icon :class="{emptyCollection: group && group.collections && group.collections.length==0}">add</v-icon></v-btn>
                                <span>Add Collection to Group</span>
                            </v-tooltip>
                        </v-flex>
                                <v-flex v-else>
                                    <v-tooltip top>                                                
                                    <v-btn slot="activator" icon><v-icon color="grey" @click.stop="">
                                        add
                                    </v-icon></v-btn>   
                                    <span>Not Owner</span>
                                    </v-tooltip>
                                </v-flex>
                        

                        <v-flex v-if="isOwner(group)">                             
                            <v-tooltip top >
                                <v-dialog slot="activator" v-model="deleteGroupDialog[groupIndex]" persistent max-width="390">
                                <v-btn slot="activator" icon><v-icon>delete</v-icon></v-btn>
                                    <v-card>
                                        <v-toolbar flat >
                                            <v-toolbar-title class="headline">Confirm Group Deletion </v-toolbar-title>
                                        </v-toolbar>  
                                        <div class="pl-2">                                    
                                            <v-card-text class="pt-4 mb-2">"{{group.groupName}}" will be deleted.</v-card-text>

                                            <v-card-text v-if="!group.viewers.length && !group.editors.length">
                                                This group has no Editors or Viewers
                                            </v-card-text> 

                                            <v-card-text v-else class="pt-0">
                                                <div class="mb-4" v-if="group.viewers.length>0">Viewers:<br>
                                                <span >
                                                    {{group.viewers.map((viewer) => { return viewer.name })}}
                                                </span>
                                                </div>
                                                <span v-else>No Viewers</span>
                                                <div class="mb-4" v-if="group.editors.length>0">Editors:<br>
                                                <span>
                                                    {{group.editors.map((editor) => { return editor.name })}}
                                                </span>
                                                </div>
                                                <span v-else>No Editors</span>
                                            </v-card-text>
                                        </div>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="green darken-1" flat @click.native="deleteGroupDialog[groupIndex] = false">No</v-btn>
                                            <v-btn color="green darken-1" flat 
                                                @click.native="deleteGroupDialog[groupIndex] = false; deleteGroup(group)">Yes
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <span>Delete Group</span>
                            </v-tooltip>
                        </v-flex>
                                <v-flex v-else>
                                    <v-tooltip top>                                                
                                    <v-btn slot="activator" icon><v-icon color="grey" @click.stop="">
                                        delete
                                    </v-icon></v-btn>   
                                    <span>Not Owner</span>
                                    </v-tooltip>
                                </v-flex>
                        
                        <!-- POPUP MENU ON GROUPS -->
                        <v-menu v-model="showMenu[groupIndex]" offset-y dark>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                            ><v-icon v-on="on" @click.stop="">
                              more_vert
                            </v-icon></v-btn> 
                          </template>
                          <v-list>
                            <v-list-tile v-if="!linkMode" @click.stop="toggleCollectionOrdering(group, groupIndex)">
                                <v-list-tile-title>{{ showCollectionsReorder ? 'Stop Reordering' : 'Reorder Collections'}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="!isOwner(group) && !linkMode">                                
                                <v-list-tile-title>
                                    <v-dialog v-model="unsubscribeGroupDialog[groupIndex]" persistent max-width="390">
                                        <span slot="activator" icon>Unsubscribe</span>
                                        <v-card class="pl-2 pt-1 pr-2">
                                            <v-card-title class="headline">Confirm Group Unsubscribe</v-card-title>
                                            <v-divider></v-divider>
                                            <v-card-text class="pt-4 body-2">
                                                {{group.groupName}}
                                            </v-card-text>
                                            <v-card-text class="pt-0 body-2">You will be removed as editor and/or viewer and<br>
                                            '{{group.groupName}}' will no longer be shown in your Room Collections.</v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="green darken-1" flat 
                                                    @click.native="unsubscribeGroupDialog[groupIndex] = false;
                                                    showMenu[groupIndex]=false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn color="green darken-1" flat 
                                                    @click.native="unsubscribeGroup(group,groupIndex)">
                                                    UNSUBSCRIBE
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile >
                                <v-list-tile-title>
                                    <v-dialog v-model="cloneGroupDialog[groupIndex]" persistent max-width="390">
                                        <span slot="activator" icon>Clone</span>
                                        <v-card>
                                        <v-toolbar flat >
                                            <v-toolbar-title class="headline">Confirm Group Clone</v-toolbar-title>
                                        </v-toolbar>  
                                        <div class="pl-2">                                    
                                            <v-card-text class="pt-4">
                                                {{group.groupName}}
                                            </v-card-text>
                                            <v-card-text class="pt-0">You will become owner of a new, unshared copy of this group.</v-card-text>
                                       </div>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="green darken-1" flat 
                                                @click.native="cloneGroupDialog[groupIndex] = false;
                                                showMenu[groupIndex]=false">
                                                Cancel
                                            </v-btn>
                                            <v-btn color="green darken-1" flat 
                                                @click.native="cloneGroupDialog[groupIndex] = false; 
                                                showMenu[groupIndex]=false;
                                                cloneGroup(group);
                                                ">
                                                CLONE
                                            </v-btn>
                                        </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click.stop="exportXLS(group); showMenu[groupIndex]=false;">
                              <v-list-tile-title>Export</v-list-tile-title>
                            </v-list-tile>
                            
                          </v-list>
                        </v-menu>


                    </v-layout>
                </v-flex>
            </v-layout>
            <v-tooltip right v-if="!showReorder && !isOwner(group) && group.owner.name.length > 0">
                <span :class="groupsOpen[groupIndex] ? 'subMoveUp' : ''"  slot="activator">
                    From: {{group.owner.name}}
                </span>
                <span>Group Owner</span>
            </v-tooltip>
            </v-layout>
            </v-layout>
            </template>

        <v-expansion-panel class="pl-3 mb-4" v-model="panelsOpen[groupIndex]" popout expand>
            <v-expansion-panel-content lazy v-for="(collection, collectionIndex) in group.collections" :key="collectionIndex"  v-bind:style="{ backgroundColor: collection.color }" >
      
                <v-layout align-center justify-space-between style="font-weight: 500;" slot="header" >
                    <v-flex xs1 v-if="showCollectionsReorder">
                        <v-icon @click.stop="changeOrder(group.collections, collectionIndex, 'up')" style="position: relative; top: 6px;">expand_less</v-icon>
                            <!-- {{collection.order}} -->
                        <v-icon @click.stop="changeOrder(group.collections, collectionIndex, 'down')" style="position: relative; top: -6px;">expand_more</v-icon>
                    </v-flex>

                    <v-flex shrink>
                        <v-tooltip top v-if="isOwner(collection) || isOwner(group) || isEditor(collection) || isEditor(group)">
                            <v-edit-dialog  @click.native.stop 
                            slot="activator"
                            :return-value.sync="collection.collection"
                            @save="rcUpdateCollection(collection)"
                            lazy>
                            <v-list-item>
          

                              <v-list-item-content>
                                <v-list-item-title v-html="collection.collection"></v-list-item-title>
                                <v-list-item-subtitle class="caption"><br>{{new Date(collection.lastSave).toLocaleString()}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          
                            
                            <v-text-field style="width: 300px;"                            
                              slot="input"
                              v-model="collection.collection"
                              label="Collection Name"
                              single-line                              
                              counter
                            ></v-text-field>
                            </v-edit-dialog>                              
                            <span>Edit Collection Name</span>
                        </v-tooltip>   
                        <span v-else>{{collection.collection}}</span>                    
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs6 v-if="!showCollectionsReorder">
                        <v-layout row>
                            <v-flex>
                                <v-tooltip top>
                                    <v-btn slot="activator" icon @click.stop="highlightRooms(collection, true)">
                                        <v-icon>control_camera</v-icon>
                                    </v-btn>
                                    <span>Center and Apply Color</span>
                                </v-tooltip>
                            </v-flex>
                    
                            <v-flex>
                                <v-tooltip top>
                                    <v-btn class="" slot="activator" icon @click.stop="changeColor(collection)">
                                        <v-icon>color_lens</v-icon>
                                    </v-btn>
                                    <span>Change Color</span>
                                </v-tooltip>
                                <ColorPicker v-on:change-color="updateColor" v-if="showColorPicker && currentCollection == collection " class="collectionColorPicker"/>
                            </v-flex>
                            
                            <v-flex v-if="isOwner(collection) || isOwner(group) || isEditor(collection) || isEditor(group)">  
                                <v-tooltip top>                                                
                                <ShareCollectionDialog slot="activator" :collection="collection" />   
                                <span>Share Collection</span>
                                </v-tooltip> 
                            </v-flex>
                            <v-flex v-else>
                                <v-tooltip top>                                                
                                <v-btn slot="activator" icon><v-icon color="grey" @click.stop="">
                                    share
                                </v-icon></v-btn>   
                                <span>Not Owner</span>
                                </v-tooltip>
                            </v-flex>
                                                                                        <!-- Lack of name indicates a link or something behind scenes api -->
                            <v-flex v-if="(isOwner(collection) || isOwner(group) || isEditor(collection) || isEditor(group)) && collection.owner.name != ''" >  
                                <v-tooltip top >
                                    <v-dialog slot="activator" v-model="deleteCollectionDialog[groupIndex*1000 + collectionIndex]" persistent max-width="390">
                                    <v-btn slot="activator"  icon><v-icon>delete</v-icon></v-btn>
                                        <v-card>
                                            <v-toolbar flat :color="collection.color">
                                                <v-toolbar-title class="headline">Confirm Collection Deletion </v-toolbar-title>
                                            </v-toolbar>  
                                            <div class="pl-2">                                    
                                                <v-card-text class="pt-4 mb-2">"{{collection.collection}}" will be deleted.</v-card-text>

                                                <v-card-text v-if="!collection.viewers.length && !collection.editors.length">
                                                    This collection has no Editors or Viewers
                                                </v-card-text> 

                                                <v-card-text v-else class="pt-0">
                                                    <div class="mb-4" v-if="collection.viewers.length>0">Viewers:<br>
                                                    <span >
                                                        {{collection.viewers.map((viewer) => { return viewer.name })}}
                                                    </span>
                                                    </div>
                                                    <span v-else>No Viewers</span>
                                                    <div class="mb-4" v-if="collection.editors.length>0">Editors:<br>
                                                    <span>
                                                        {{collection.editors.map((editor) => { return editor.name })}}
                                                    </span>
                                                    </div>
                                                    <span v-else>No Editors</span>
                                                </v-card-text>
                                            </div>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="green darken-1" flat @click.native="deleteCollectionDialog[groupIndex*1000 + collectionIndex] = false">No</v-btn>
                                                <v-btn color="green darken-1" flat 
                                                    @click.native="deleteCollectionDialog[groupIndex*1000 + collectionIndex] = false; deleteCollection(group, collection)">Yes
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <span>Delete Collection</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex v-else-if="group.owner.name==''"> <!-- Indication this is a 'groupless' shared collection -->
                                <v-tooltip top >
                                    <v-dialog slot="activator" v-model="unsubscribeCollectionDialog[groupIndex*1000 + collectionIndex]" persistent max-width="390">
                                    <v-btn slot="activator"  icon><v-icon>delete</v-icon></v-btn>
                                        <v-card class="pl-2 pt-1 pr-2">
                                            <v-card-title class="headline">Confirm Unsubscribe from Collection</v-card-title>
                                            <v-divider></v-divider>
                                            <v-card-text class="pt-4 body-2">You will no longer see this collection.</v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="green darken-1" flat @click.native="unsubscribeCollectionDialog[groupIndex*1000 + collectionIndex] = false">Cancel</v-btn>
                                                <v-btn color="green darken-1" flat 
                                                    @click.native="unsubscribeCollectionDialog[groupIndex*1000 + collectionIndex] = false; unsubscribeCollection(group, collection, groupIndex)">UNSUBSCRIBE
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <span>Unsubscribe</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex v-else>
                                <v-tooltip top>                                                
                                <v-btn slot="activator" icon><v-icon color="grey" @click.stop="">
                                    delete
                                </v-icon></v-btn>   
                                <span>Not Owner</span>
                                </v-tooltip>
                            </v-flex>

                        </v-layout>
                    </v-flex>
                </v-layout>

                <v-card class="pt-2" :class="{emptyCollection: roomCollectionAutoAdd === collectionIndex}"  >
                    <v-layout row justify-space-between class="pr-3"
                        v-if="!$vuetify.breakpoint.xsOnly && !linkMode && (isOwner(collection) || isEditor(collection) || isEditor(group) || isOwner(group))">
                        <v-btn @click="enableAutoAdd(collection, groupIndex*1000 + collectionIndex)" class="ml-4">
                            {{roomCollectionAutoAdd === groupIndex*1000 + collectionIndex ? 'Stop Adding' : 'Add Rooms'}}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn @click="exportXLS({ 'groupName': '', 'collections':[collection] })">Export</v-btn>
                        <MoveDialog :collection="collection" :groups="collections" v-on:refresh="refresh"/>                 
                    </v-layout>
                    <v-divider v-if="!$vuetify.breakpoint.xsOnly && (isOwner(collection) || isOwner(group) || isEditor(collection) || isEditor(group))" class="mt-2"></v-divider>
                    <v-list two-line>
                        <template >
                            
                            <v-container class="textsize">   
                                <v-list-tile class="coltile">
                                    <v-list-tile-content >
                                        <v-list-tile-title class="caption" >
                                            <v-layout justify-space-between :class="{ textsize : $vuetify.breakpoint.xsOnly}">
                                                <v-flex xs1>
                                                    <b>Bldg</b>
                                                </v-flex>
                                                <v-flex xs1>
                                                    <b>Room</b>
                                                </v-flex>
                                                <v-flex xs1 class="text-xs-center">
                                                    <b>Floor</b>
                                                </v-flex>
                                                <v-flex xs4 >
                                                    <b>Department</b>
                                                </v-flex>
                                                <v-flex xs2 class="ml-2">
                                                    <b>Category</b>
                                                </v-flex>
                                                <v-flex xs1 class="text-xs-right">
                                                    <b>Area</b>
                                                </v-flex>
                                                <v-flex xs1 v-if="isOwner(collection) || isOwner(group) || isEditor(collection) || isEditor(group)"/>
                                                                                    
                                            </v-layout>
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>                              
                                <v-list-tile    class="coltile" 
                                                v-for="(room, i) in collection.rooms" 
                                                :key="i"
                                                @click="goToRoom(room.bldgAlpha, room.roomKey)">
                                    <v-list-tile-content class="crosshair" >
                                        <v-list-tile-title class="caption" >
                                            <v-layout justify-space-between :class="{ textsize : $vuetify.breakpoint.xsOnly}">
                                                <v-flex xs1>
                                                    {{room.bldgAlpha}}
                                                </v-flex>
                                                <v-flex xs1>
                                                    {{room.number}}
                                                </v-flex>
                                                <v-flex xs1 class="text-xs-center">
                                                    {{room.floor}}
                                                </v-flex>
                                                
                                                <v-flex xs4 class="overflow-hidden">
                                                    <v-tooltip top>
                                                        <v-flex slot="activator">
                                                            {{room.department}}
                                                        </v-flex>
                                                        <span>{{room.department}}</span>
                                                    </v-tooltip>
                                                </v-flex>                                                    
                                                
                                                <v-flex xs2 class="ml-2 overflow-hidden" >
                                                    <v-tooltip top>
                                                        <v-flex slot="activator">
                                                            {{room.categoryName}}
                                                        </v-flex>
                                                        <span>{{room.categoryName}}</span>
                                                    </v-tooltip>
                                                </v-flex>

                                                <v-flex xs1 class="text-xs-right">
                                                    {{room.area && room.area.toLocaleString()}}
                                                </v-flex>
                                                <v-flex xs1 v-if="isOwner(collection) || isOwner(group) || isEditor(collection) || isEditor(group)">  
                                                    <v-btn @click.stop="deleteRoom(collection, room)" icon style="top:-12px;">
                                                        <v-icon small>clear</v-icon>
                                                    </v-btn>  
                                                </v-flex>  
                                            </v-layout>
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile class="coltile" v-if="collection.rooms.length > 0">

                                    <v-list-tile-content >
                                        <v-divider class="rc_divider"></v-divider>
                                        <v-list-tile-title class="caption" >
                                            <v-layout justify-space-between>
                                                <v-flex xs1 />                                                
                                                <v-flex xs1 />  
                                                <v-flex xs1 />                                                                          
                                                <v-flex xs4 />   
                                                <v-flex xs2 />                                               
                                                <v-flex xs1 class="text-xs-right">
                                                    <b>{{areaTotal(collection.rooms)}}</b>
                                                </v-flex>
                                                <v-flex xs1 v-if="isOwner(collection) || isOwner(group) || isEditor(collection) || isEditor(group)" />
                                            </v-layout>
                                        </v-list-tile-title>
                                    </v-list-tile-content>

                                </v-list-tile> 
                            </v-container>
                        </template>
                    </v-list>
                </v-card>
            </v-expansion-panel-content>
            
        </v-expansion-panel>
        </v-expansion-panel-content>
    </v-expansion-panel>
        <v-layout row justify-space-between>
            <v-btn class="mt-4 ml-0" v-if="collections.length>0" @click="exportXLS(collections)">
                <v-icon left>save_alt</v-icon>
                Export All
            </v-btn>
        </v-layout>
    </v-layout>


</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import Vue from 'vue'
import XLSX from 'xlsx'

import ColorPicker from '../buildingcard/ColorPicker'
import ShareCollectionDialog from '../forms/ShareCollectionDialog'
import ShareCollectionGroupDialog from '../forms/ShareCollectionGroupDialog'
import MoveDialog from './MoveDialog'
import hexRgb from'hex-rgb'

import { loadModules } from 'esri-loader';
import HelpRoomCollections from '@/components/help/HelpRoomCollections'
import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'
//import { TEST_DATA } from '@/RCTestData'

let RoomCollections = {

data() {
  return {
    showColorPicker: false, 
    currentCollection: null,   
    panelsOpen: [ [] ],
    groupsOpen: [],
    deleteCollectionDialog: {},
    deleteGroupDialog: {},
    unsubscribeGroupDialog: {},
    unsubscribeCollectionDialog: {},
    cloneGroupDialog: {},
    showMenu: {},
    showReorder: false,
    showCollectionsReorder: false,
    linkMode: false,
    roomClickHandler: null,
  }
},

components: { ColorPicker, ShareCollectionDialog, ShareCollectionGroupDialog, HelpRoomCollections, MoveDialog, EmployeeAutocomplete },

mounted: async function() {

    // Get Collections.
    // If we have a room collection link, grab that.  Otherwise, do default fetch.
    if (this.$route.params.link) {
        console.log("RC Link: ", this.$route.params.link)
        await this.fetchRoomCollectionsByUrl(this.$route.params.link)
        this.highlightRooms(this.collections[0])
        this.linkMode=true
    } else {
        this.setRcLoading(true)
        await this.fetchRoomCollections()
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //this.setRoomCollections(TEST_DATA)  // Bypass API
    ////////////////////////////////////////////////////////////////////////////////////////////////////

    this.setRcLoading(false)    // turn off loading bar
    
    //this.addOrderingToData() // Add ordering if its not already present

    // FIRST TIME USERS: Create group if there are none.   Open Help. 
    if (this.collections.length == 0) {
        console.log("First time user of Room Collections")
        this.setShowHelpRoomCollections(true)
        let groupId = await this.addGroup()                
    }

    // If there is only one group, open it
    if (this.collections.length == 1) { 
        this.groupsOpen = [true]                 
    }

    // If the only group has only one collection, open it
    if (this.collections[0].collections.length == 1) {
        this.panelsOpen[0] = [true]
    }
},

computed: {
    ...mapState({
            isSuperUser:            state => state.user.isSuperUser,
            selectedRoom:           state => state.space.selectedRoom,
            selectedBuilding:       state => state.space.selectedBuilding,
            highlightRoomsByKey:    state => state.mapFunctions.highlightRoomsByKey,
            clearGraphics:          state => state.mapFunctions.clearGraphics,
            removeGraphic:          state => state.mapFunctions.removeGraphic,
            roomCollections:        state => state.roomCollections.roomCollections,
            currentFloor:           state => state.ui.currentFloor, 
            stateMap:               state => state.mapFunctions.stateMap,
            collectionSidebarOpen:  state => state.ui.collectionSidebarOpen,
            roomCollectionAutoAdd:  state => state.ui.roomCollectionAutoAdd,
            netId:                  state => state.user.userProfile.netid,
            darkTheme:              state => state.ui.darkTheme,
            rcLoading:              state => state.roomCollections.rcLoading,
        }),
    ...mapGetters(['getRoom']),
    
    collections: {
        get () {
            // Sort each collection in each group by 'order'
            this.roomCollections.forEach((group) => {
                group.collections.sort((a, b) => (a.order < b.order) ? 1 : -1)
            })

            // Sort the groups and return
            //console.log("Sort Groups")
            // Two property sort, first on netid, then on order            
            this.roomCollections.sort((a, b) => (a.order < b.order) ? 1 : -1 )
            this.roomCollections.sort((a, b) => a.owner.netid.localeCompare(!this.netId))
            return this.roomCollections
        },
        set (value) { this.setRoomCollections(value) }
    },
},

watch: {
    panelsOpen (val) { this.reset() }
},

props: ['showImpersonate'],

methods: {
    ...mapActions([     'selectBuilding', 
                        'fetchFullRoom', 
                        'rcAddGroup', 
                        'rcAddCollection', 
                        'centerOverRooms', 
                        'rcDeleteGroup', 
                        'rcDeleteCollection',
                        'fetchRoomCollections', 
                        'rcUpdateGroup', 
                        'rcUpdateCollection',
                        'fetchRoomCollectionsByUrl', 
                        'rcUnsubscribeGroup',
                        'rcUnsubscribeCollection', 
                        'rcCloneGroup']),

    ...mapMutations([   'setSelectedRoom',
                        'setRoomCollections',
                        'setCurrentFloor',
                        'setShowHelpRoomCollections',
                        'updateSelectionCentering',
                        'setRoomCollectionAutoAdd',
                        'setMultiSelectRoomArray',
                        'setSnackText',
                        'setRcLoading'
                    ]),
    
    async refresh(groupId) {
        console.log("Refresh")
        this.setRcLoading(true)
        await this.fetchRoomCollections()
        this.setRcLoading(false)
        this.closeAllPanels()

        if (groupId) {
            let index = this.collections.findIndex((collection) => collection.groupId == groupId)
            let group = this.collections.find((collection) => collection.groupId == groupId)

            // Open the group
            let groups = [ ...this.groupsOpen]
            groups[index] = [true]
            this.groupsOpen = [ ...groups ]; // object copy force reaction
            
            // Open the new collection
            console.log("Panels: ", this.panelsOpen, )
            let panels = []
            panels[group.collections.length-1] = [true]
            this.panelsOpen[index] = [ ...panels ]; // object copy force reaction 
        }
    },

    async retrieveCollectionsByUser (employee) {
        this.setRcLoading(true)
        
        if (!employee) {
            await this.fetchRoomCollections()  
            this.$emit('updateShowImpersonate', false)        
        } else {
            await this.fetchRoomCollections(employee.employeeID)
        }

        this.setRcLoading(false)       
        return

    },

    toggleShowOrdering: function () {
        this.closeAllPanels() 
        this.showReorder = !this.showReorder
    },

   toggleCollectionOrdering: function (group, groupIndex) {
        this.closeAllPanels() 
        this.showCollectionsReorder = !this.showCollectionsReorder
        this.groupsOpen[groupIndex]=true
        this.showMenu[groupIndex]=false;
    },

    switchCollections() {        
        this.linkMode=false
        this.$router.replace("/") // change URL
        this.fetchRoomCollections()
    },

    isOwner: function (object) {
        if (object.owner && object.owner.netid == this.netId) { return true}
    },

    isEditor: function (object) {

        if (object.editors.find((editor) => {return editor.netid === this.netId })) { return true }
    },

    // returns currentFloor rooms from the collection
    floor: function (collection) {
        return collection.rooms.filter((room) => room.floor == this.currentFloor)//.length > 0 ? true : false
    },

    groupFloorRooms: function (group) {
        let rooms = []
        group.collections.forEach((collection) => {
            rooms = rooms.concat(collection.rooms.filter((room) => room.floor == this.currentFloor))
        })
        return rooms
    },

    areaTotal : function (rooms) {
        return (rooms.length>0) ? rooms.map((rooms) => { return parseInt(rooms.area)}).reduce((total, amount) => total + amount).toLocaleString() : null                
    },

    closeAllPanels() {
        this.panelsOpen= [ [] ]
        this.groupsOpen=[]
    },

    addCollection: async function(group, index) {
        console.log("Adding Collection")
        this.setRcLoading(true)
        // Get the current max order from the list
            let minOrder = 0
            group.collections.forEach((collection) => {
                if (collection.order < minOrder) { minOrder = collection.order }  
            })
            minOrder = minOrder - 100

        const name = group.collections.length > 0 ? "Collection " + group.collections.length : "My Collection"
        
        console.log("MinOrder: ", minOrder)
        await this.rcAddCollection({ groupId: group.groupId, collection: { collection : name, order: minOrder, color : this.getHue() }})
        
        // Refresh Data.  Might prefer to use a reset function here
        await this.fetchRoomCollections()
        this.setRcLoading(false)

        this.closeAllPanels()        

        // Open the group
        let groups = [ ...this.groupsOpen]
        groups[index] = true
        this.groupsOpen = [ ...groups ]; // object copy force reaction
        
        // Open the new collection
        console.log("Panels: ", this.panelsOpen, index)
        let panels = []
        panels[0] = true
        this.panelsOpen[index] = [ ...panels ]; // object copy force reaction                
    },

    addGroup: async function () {
        // Get the current max order from the list
        this.setRcLoading(true)
        let nextOrder = 0
        this.collections.forEach((group) => { if (group.order > nextOrder) { nextOrder = group.order } })
        nextOrder = nextOrder + 100

        const name = this.collections.length > 0 ? "Group " + parseInt(this.collections.length+1) : "My First Collection Group"
        const group = { group: name, collectionColor: this.getHue(), order: nextOrder }
        
        // Ask api to create group
        await this.rcAddGroup(group)
        this.setRcLoading(false)

        // Refresh Data
        await this.fetchRoomCollections()

        this.closeAllPanels()        

        // Open the group
        let groups = [ ...this.groupsOpen]
        groups[this.collections.length-1] = [true]
        this.groupsOpen = [ ...groups ]; // object copy force reaction
        
        // Open the new collection
        console.log("Panels: ", this.panelsOpen, )
        let panels = []
        panels[0] = [true]
        this.panelsOpen[this.collections.length-1] = [ ...panels ]; // object copy force reaction  

    },

    deleteCollection: async function (group, collectionToDelete) {
        this.setRcLoading(true)
        this.removeGraphic(collectionToDelete.rooms.map((room) => {return room.roomKey} ))
        await this.rcDeleteCollection({ collectionId: collectionToDelete.collectionId })
        group.collections = group.collections.filter((collection) => collection != collectionToDelete)
        this.reset()
        this.setRcLoading(false)
    },

    deleteGroup: async function (groupToDelete) {
        // TODO: Clear Graphics
        this.setRcLoading(true)
        await this.rcDeleteGroup({ groupId: groupToDelete.groupId })
        this.collections = this.collections.filter((group) => group != groupToDelete)
        this.closeAllPanels()
        this.reset()
        this.setRcLoading(false)
    },

    unsubscribeGroup: function (groupToUnsub, groupIndex) {
        this.unsubscribeGroupDialog[groupIndex] = false
        this.showMenu[groupIndex]=false
        this.rcUnsubscribeGroup({ groupId: groupToUnsub.groupId })
        this.collections = this.collections.filter((group) => group != groupToUnsub)
        this.closeAllPanels()
    },

    unsubscribeCollection: async function (groupToUnsub, collectionToUnsub, groupIndex) {
        await this.rcUnsubscribeCollection({ collectionId: collectionToUnsub.collectionId })
        this.fetchRoomCollections()
        this.closeAllPanels()
    },

    async cloneGroup(group) {
        this.setRcLoading(true)
        await this.rcCloneGroup({ guid: group.guid })
        this.reset()
        await this.fetchRoomCollections()
        this.closeAllPanels()
        this.setRcLoading(false)
    },

    deleteRoom: function (collection, roomToDelete) {
        // filter out roomToDelete
        collection.rooms = collection.rooms.filter((room) => room != roomToDelete)
        
        // Remove from highlight array
        let delArray = []
        delArray.push(roomToDelete.roomKey)
        this.removeGraphic(delArray)

        // Save to database
        this.rcUpdateCollection(collection)
    },

    addRoom: function(addRoom) {  // addRoom is our standard room object from API
        // Create a room object from addRoom, deduplicate
        // add graphic to highlight layer
        // Update Collection
        
        if (!this.currentCollection.rooms.find((room) => room.number === addRoom.number && room.bldgAlpha === addRoom.bldgAlpha)) {  // prevent duplicate
            
            this.currentCollection.rooms.push(
                {   
                    key : addRoom.key, 
                    //joinKey: this.selectedRoom.dwgName + ".dwg+" + this.selectedRoom.ehandle,
                    roomKey: addRoom.roomKey,
                    bldgAlpha: addRoom.bldgAlpha,
                    floor:addRoom.floor,
                    number: addRoom.number, 
                    area: addRoom.area,
                    department: addRoom.deptName,
                    categoryName: addRoom.categoryName
                })

            this.addSingleGraphic(addRoom.roomKey, this.currentCollection.color)
            //this.rcUpdateCollection(this.currentCollection)                 
        }
    },

    // Reorders group and collection arrays per user interaction
    changeOrder: function(object, index, direction) {       
        //console.log("change Order", index, direction)
        let prevItem    = object[index - 1]      
        let item        = object[index]      
        let nextItem    = object[index + 1]  
        
        if (direction == "up" && prevItem) {   
            let thisOrder = item.order.valueOf()        // valueOf should copy without making pointer
            let prevOrder = prevItem.order.valueOf()
            
            item.order = prevOrder      // set this item's order to prevorder
            prevItem.order = thisOrder  // set previous item's order to this order.  Swap them.

            // Use set to trigger reactivity
            Vue.set(object, index-1, prevItem)
            Vue.set(object, index, item)   

            // Save Changes
            if (object[0].groupId) { // if this is a group
                this.rcUpdateGroup(prevItem)
                this.rcUpdateGroup(item)  
            } else {
                this.rcUpdateCollection(item) 
                this.rcUpdateCollection(nextItem)
            }               

        } else if (direction == "down" && nextItem) {
            let thisOrder = item.order.valueOf()
            let nextOrder = nextItem.order.valueOf()
            item.order = nextOrder
            nextItem.order = thisOrder

            // Use set to trigger reactivity
            Vue.set(object, index, item)
            Vue.set(object, index+1, nextItem)

            // Save Changes
            if (object[0].groupId) { // if this is a group
                this.rcUpdateGroup(item) 
                this.rcUpdateGroup(nextItem)
            } else {
                this.rcUpdateCollection(item) 
                this.rcUpdateCollection(nextItem)
            }
            
        }
    },

    addSingleGraphic: function (roomKey, color) {
        const vm = this

        loadModules(["esri/map", "esri/layers/GraphicsLayer", "esri/symbols/SimpleLineSymbol", "esri/symbols/SimpleFillSymbol", "esri/Color", "esri/graphic",])
        .then(([Map, GraphicsLayer, SimpleLineSymbol, SimpleFillSymbol, Color, Graphic]) => {
            const roominteractivityLayer = vm.stateMap.getLayer('roominteractivitylayer')
            const multihighlightLayer = vm.stateMap.getLayer('multihighlightlayer')
            const fGraphic = roominteractivityLayer.graphics.find(graphic => {return graphic.attributes["ROOMEXT.roomKey"] === roomKey});

            if (fGraphic) {                                  
                const hGraphic = new Graphic(fGraphic.toJson()) // Copy the graphic, otherwise its a pointer  
                const symbol = new SimpleFillSymbol("solid", new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID, Color.fromRgb(color), 3), Color.fromRgb(color));
                hGraphic.setSymbol(symbol)

                // Detect Duplicate in highlight layer - NOT NEEDED because its deduped before it gets this far.
                //const dupGraphic = multihighlightLayer.graphics.find(graphic => { return graphic.attributes["ROOMEXT.roomKey"] === roomKey });
                //if (dupGraphic) { console.log("Already Highlighted", dupGraphic); return; }
                
                //Add to MultiHighlight Layer
                multihighlightLayer.add(hGraphic);
            }
        })
    },

    enableAutoAdd: function (collection, index) {

        if (this.roomCollectionAutoAdd == index) {      // If its turned on, turn it off and save collection.
            this.setRoomCollectionAutoAdd(null)
            this.rcUpdateCollection(this.currentCollection) 
        } else {            
            if (collection.rooms.length>0) {                 
                this.highlightRooms(collection, true)   // Highlight rooms already in the collection
            }
            this.setRoomCollectionAutoAdd(index)
        }
        this.currentCollection = collection
        const vm = this

        const hoverhighlightLayer = vm.stateMap.getLayer('hoverhighlightlayer')
        
        this.roomClickHandler && this.roomClickHandler.remove() // Prevent duplicate up of event handlers
        this.roomClickHandler = hoverhighlightLayer.on("mouse-up", function(evt) {
            if (vm.roomCollectionAutoAdd != null) {
                console.log("Click Detected")
                let roomKey = evt.graphic.attributes["ROOMEXT.roomKey"]
                let bldg = evt.graphic.attributes["ROOMEXT.BldgAlpha"]
                let roomNumber = evt.graphic.attributes["ROOMEXT.RM_ID"]
                let room = vm.getRoom(roomKey)
                if (!room) { 
                    vm.fetchFullRoom({bldgAlpha: bldg, number: roomNumber, noSet: true}).then((data) => {
                        vm.addRoom(data)
                    })
                } else {
                    vm.addRoom(room)
                }
            }
        })

    },

    goToRoom: function(bldg, roomKey) {
        if (this.selectedBuilding && this.selectedBuilding.bldgAlpha == bldg) {
            this.setSelectedRoom(this.getRoom(roomKey))
        } else {
            this.updateSelectionCentering(true)
            this.selectBuilding(bldg).then(() => this.setSelectedRoom(this.getRoom(roomKey)))                   
        }
         this.fetchFullRoom(this.selectedRoom)
    },

    getHue: function () {
        return 'rgba(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + '0.5)';               
        //return 'white'
    },

    changeColor: function (collection) {
        //collection.color = this.getHue()
        this.currentCollection = collection
        this.showColorPicker = true
    },

    updateColor: function (value) {
        //const myCollection = this.collections.find((collection) => collection == this.currentCollection)
        //myCollection.color = `rgba(${hexRgb(value).red}, ${hexRgb(value).green}, ${hexRgb(value).blue}, 0.5)`
        this.currentCollection.color = `rgba(${hexRgb(value).red}, ${hexRgb(value).green}, ${hexRgb(value).blue}, 0.5)`
        this.showColorPicker = false
        this.highlightRooms(this.currentCollection, false)
        this.rcUpdateCollection(this.currentCollection)
        event.stopPropagation()
    },

    highlightRooms: function (payload, centerAndZoom) {
        // Clear colorizing Layer.  Not sure why this was added, but shouldn't hurt
        this.clearGraphics('colorlayer') 

        // Groups are processed differently
        // Will color current floor if there are any rooms in the group
        // If no rooms on current floor, will switch to first valid floor
        if (payload.groupName) {
            console.log("Group Highlight")                  

            // If no rooms were found on the current floor for the whole group
            // Assign currentFloor to first valid in group.
            if (this.groupFloorRooms(payload).length == 0) {
                this.setCurrentFloor(payload.collections[0].rooms[0].floor)  // Will fail if user has empty room collection.
            }

            // Iterate Collections and Highlight
            payload.collections.forEach((collection) => {

                // Check if this collection has rooms on currentFloor 
                if (this.floor(collection).length > 0) {
                    this.highlightRoomsByKey(this.floor(collection).map((room) => { return room.roomKey } ), collection.color, centerAndZoom)
                }                            
            })

            // Center the map over the set of colored rooms for this group, for this floor
            this.centerOverRooms({ rooms: this.groupFloorRooms(payload) })

        // This code is for collections (not groups)
        } else {
        
        // If there are no rooms for the current floor, switch to the first valid floor in the payload
        console.log("Return of floorcheck:", this.floor(payload))
        if (this.floor(payload).length == 0) {
            console.log("No collection rooms for this floor. Changing to first valid floor")
            this.setCurrentFloor(payload.rooms[0].floor)
        }   
        
        this.highlightRoomsByKey(this.floor(payload).map((room) => { return room.roomKey } ), payload.color, centerAndZoom)   
        }          
    },

    reset: function () {
        this.currentCollection = null
        this.setRoomCollectionAutoAdd(null)
    },

    exportXLS: function (payload) {
        // A workbook is the name given to an Excel file
        var wb = XLSX.utils.book_new() // make Workbook of Excel

        var collectionWS = []
        var collectionNames = []

        // Create worksheet, and add info
        let ws = XLSX.utils.aoa_to_sheet([
                ["Interactive Floorplans - Room Collections Export"],
            ])

        if (payload.length) {
            // This is all groups
            payload.forEach((group) => {
                this.exportCollections(group, ws)
            })
        } else {
            // This is one group              
            let group = payload
            this.exportCollections(group, ws)
        }                

        // Column Widths
        var wscols = [
            {wch:8},
            {wch:8},
            {wch:8},
            {wch:36},
            {wch:36},
            {wch:8},                   
        ];

        ws['!cols'] = wscols;
          
        XLSX.utils.book_append_sheet(wb, ws, "Room Collections")


        // export Excel file
        XLSX.writeFile(wb, 'RoomCollections.xlsx') // name of the file is 'book.xlsx'   

    },

    // This is adding a lot of extra spaces.  Proportional to the number of rooms output.
    // Could be related to origin: -1.  Was not able to fix so far.
    exportCollections: function (payload, ws) {
        payload.collections.forEach((collection, index) => {
            XLSX.utils.sheet_add_aoa(ws, [
                    [""],
                    [payload.groupName],    // Group Name
                ], { origin: -1 })
            XLSX.utils.sheet_add_aoa(ws, [
                    [collection.collection],    // Collection Name
                ], { origin: -1 })
            XLSX.utils.sheet_add_json(ws, 
                collection.rooms.map((room) => {
                    return { Bldg: room.bldgAlpha, 
                             Floor: room.floor,
                             Room: room.number,
                             Department: room.department,
                             Category: room.categoryName,
                             Area: room.area
                           } 
                }),
                { origin: -1 } // -1 means add to end of worksheet
            )
        })
    }
    
}
} 
export default RoomCollections
</script>

<style>
.loading {
    position: relative;
    pointer-events: none;
    opacity: 0.5; /* You can adjust this to visually indicate loading */
}

.shiftUp {
    position: relative;
    top: -25px;
}

.coltile > .v-list__tile {
    align-items:  flex-start;
    height: auto !important;
    margin-bottom: 5px;
}

.rc_divider {
    flex: none !important;
}

.collectionColorPicker {
    position: relative;
    top: -45px;
    left: -80px;
    width: 200px;
    z-index: 1;
}

@keyframes glowing {
  0% { box-shadow: 0 0 -10px #e61010; }
  40% { box-shadow: 0 0 30px #e61010; }
  60% { box-shadow: 0 0 30px #e61010; }
  100% { box-shadow: 0 0 -10px #e61010; }
}

.emptyCollection {
    border-radius: 20px;    
    animation: glowing 2000ms infinite;
}

/*.theme--dark .v-menu__content {
  background-color: #424242;
}
.theme--light .v-menu__content {
  background-color: #ffffff;
}*/

.textsize {
    font-size: 6pt;
}

.subMoveUp {
    position: relative;
    top: -10px;
}

.groupStyle {
    background-color: rgb(244 244 244) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/RoomCollector/RoomCollections.vue